import { fetchApi } from "@/utils/axios";
import http from "@/utils/axios";

// 管理端接口前缀（文档：rhub-appointment-api.md 二、管理端接口）
const prefix = "/api/dscloud-activity/rhub/admin/appointment";
// 预约类型树复用用户端接口（筛选下拉用）
const typeUrl = "/api/dscloud-activity/rhub/appointment/types";

/**
 * @description: 预约类型列表（两级树：招商/银行 → 子类）
 * @return {Array} [{ id, typeName, parentId, children: [{ id, typeName, parentId }] }]
 **/
export const getAppointmentTypes = () => {
    return fetchApi(typeUrl);
};

/**
 * @description: 预约单分页查询
 * @param {Object} params { startDate, endDate, typeId, status, phone, companyName, industry, bank, developmentStage, page, size }
 * @return {Object} { page, size, total, items }
 **/
export const getAppointmentList = (params) => {
    return fetchApi(prefix + "/list", params, "get", "params");
};

/**
 * @description: 导出预约单Excel（文件流）
 * @param {Object} params 查询条件同列表（不含分页）；传 ids 按选中导出，不传按条件全量导出
 **/
export const exportAppointment = (params) => {
    return http({
        url: prefix + "/export",
        method: "get",
        params,
        responseType: "blob",
        timeout: 120000
    });
};

/**
 * @description: 关闭预约单（仅「已预约」可关闭，关闭后状态变为已取消，时段名额即时释放）
 * @param {Number} id 预约单ID
 **/
export const closeAppointment = (id) => {
    return fetchApi(prefix + "/" + id + "/close", {}, "put");
};
